<template>
    <!-- <p>test</p> -->
    <div style="height:100%">
    <form-i539-pdf v-if="showFilePreview" :pdfFormUrl="PDFURL"></form-i539-pdf>
    </div>
</template>
<script>
import FormI539PDF  from "./FormI539PDF.vue"

export default{
    beforeRouteLeave (to, from, next) {
	const answer = window.confirm('Are you sure you want to leave the page? If you leave the page without saving the changes, the data may not be saved.')
	if (answer) {
	  next()
	} else {
	  next(false)
	}
  },
   
   data(){
     return {
      PDFURL:'',
      showFilePreview:false
     }
   },
   components:{
     'form-i539-pdf' : FormI539PDF
   },
   created(){
     this.getPDFFormURL()
   },
   methods:{
       getPDFFormURL(){
           var apiUrl = ''
           if(this.$route.params.type=='I539')
            {
                apiUrl = `FormI539/${this.$route.params.id}/PdfLink`
            }else{
                apiUrl = `FormI539A/${this.$route.params.id}/PdfLink`
            }
            ajax.get(apiUrl, {}, (res) =>{
                if(res.data.state == true){
                 this.PDFURL =  res.data.pdfLink
                 this.showFilePreview = true
                    this.$loading().close() 
                    // this.$message({
                    //     type: 'success',
                    //     message: res.data.message
                    // })
                   // events.fire("LoadI539Details")
                }
                else{
                   this.$loading().close() 
                   
                   this.$message({
                       type: 'error',
                       message: res.data.message
                    })
                }
            },{},'FormI539')
       }
   }
}
</script>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI539/ElectronicFormI539.vue